import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AddBankSVG } from '../../../../svgComponents/addBankSVG';
import { AddCardSVG } from '../../../../svgComponents/addCardSVG';
import {
    ADD_PAYMENT_METHOD,
    CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT
} from '../AddPaymentMethodModal.actions';
import styles from './ChoosePaymentMethod.module.css';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToLinkDebitCard: () =>
        dispatch({ type: ADD_PAYMENT_METHOD, paymentMethodType: 'DEBIT_CARD' }),
    goToLinkBankAccount: () =>
        dispatch({ type: CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const ChoosePaymentMethod = ({
    goToLinkDebitCard,
    goToLinkBankAccount
}: PropsFromRedux) => {
    return (
        <>
            <div className={styles.ChoosePaymentMethod}>
                <div className={styles.title}>
                    <FormattedMessage
                        id="_.modal.choose_payment_method_title"
                        defaultMessage="Would you like to link a debit card or add bank details?"
                    />
                </div>
                <div className={styles.actions}>
                    <button
                        onClick={goToLinkDebitCard}
                        className={styles.debitCardBtn}
                    >
                        <AddCardSVG className={styles.debitCardSVG} />
                        <div className={styles.actionTitle}>
                            <FormattedMessage
                                id="_.modal.choose_payment_method_debit_card"
                                defaultMessage="Debit card"
                            />
                            <div className={styles.actionDescription}>
                                <FormattedMessage
                                    id="_.modal.choose_payment_method_used_for_repayments"
                                    defaultMessage="Used for repayments"
                                />
                            </div>
                        </div>
                    </button>
                    <button
                        onClick={goToLinkBankAccount}
                        className={styles.bankAccountBtn}
                    >
                        <AddBankSVG />
                        <div className={styles.actionTitle}>
                            <FormattedMessage
                                id="_.modal.choose_payment_method_bank_account"
                                defaultMessage="Bank account"
                            />
                            <div className={styles.actionDescription}>
                                <FormattedMessage
                                    id="_.modal.choose_payment_method_used_for_fundings"
                                    defaultMessage="Used for fundings"
                                />
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(ChoosePaymentMethod);
